import type { MultipleQueriesQuery } from "@algolia/client-search"

import { JOB_ADS_QUERY_KEY } from "@/modules/jobAds/client/api/constants"

export const getJobAdsFromAlgoliaQueryKeys = ({ query, params, indexName }: MultipleQueriesQuery): unknown[] => {
  return [
    `${JOB_ADS_QUERY_KEY}::search`,
    "withAlgolia",
    {
      aroundLatLng: params?.aroundLatLng || "",
      aroundRadius: params?.aroundRadius || "",
      filters: params?.filters || "",
      indexName,
      optionalFilters: params?.optionalFilters || "",
      page: params?.page || 0,
      query: query || "",
    },
  ]
}
